<template>
  <b-container>
    <div class="vdist">
      <b-row v-for="u in users" :key="u.id" class="my-1">
        <b-col cols="2" md="1">{{ u.id }}</b-col>
        <b-col cols="10" md="3">{{ u.login }}</b-col>
        <b-col cols="12" md="3">
          <b-select v-model="u.label" @change="update_user(u)">
            <b-select-option value="NORMAL">normalny</b-select-option>
            <b-select-option value="PRO">pro</b-select-option>
            <b-select-option value="TEAM">zespół</b-select-option>
          </b-select>
        </b-col>
        <b-col cols="16" md="5" class="text-right">
          <b-button :class="{active: u.role==='USER'}" variant="primary" @click="update_role(u, 'USER')" right>
            user
          </b-button>
          <b-button :class="{active: u.role==='ADMIN'}" @click="update_role(u, 'ADMIN')" variant="primary">
            admin
          </b-button>
          <b-button @click="user_pass_reset(u)" variant="primary">
            reset
          </b-button>
          <b-button @click="user_delete_mark(u)" variant="danger">
            usuń
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-form-group>
      <b-input-group>
        <b-input type="text" v-model="new_login"></b-input>
        <b-input-group-append>
          <b-button @click="user_create()">nowy użytkownik</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-alert variant="info" :show="create_user_message!==null" class="vdist">
        {{ create_user_message }}
      </b-alert>
    </b-form-group>

    <b-modal id="user-delete-modal" hide-footer>
      <template #modal-title>
        Usuwanie użytkownika
      </template>
      <div class="d-block">
        Usunięcie użytkownika jest nieodwracalne i wiąże się z <b>utratą jego wszystkich głosów</b>.
      </div>
      <b-button class="mt-3" block @click="user_delete_reset">anuluj</b-button>
      <b-button class="mt-3" variant="danger" block @click="user_delete_marked">usuń</b-button>
    </b-modal>
  </b-container>

</template>

<script>

import {api} from '@/utils'


export default {
  name: 'usersPage',
  components: {},
  props: ["axios"],
  data: function () {
    return {
      users: [],
      new_login: "",
      create_user_message: null,
      user_to_delete: null
    }
  },
  created() {
    this.loadUsers();
  },
  methods: {
    loadUsers() {
      this.axios.get(api("users"))
          .then(resp => {
            this.users = resp.data
          })
    },
    user_delete_marked() {
      this.axios.delete(api(`users/${this.user_to_delete.id}`))
          .then(() => {
            this.loadUsers()
          }).finally(this.user_delete_reset)
    },
    user_delete_mark(user) {
      this.user_to_delete = user;
      this.$bvModal.show("user-delete-modal")
    },
    user_delete_reset() {
      this.user_to_delete = null;
      this.$bvModal.hide("user-delete-modal")
    },
    update_user(user) {
      this.axios.put(api(`users/${user.id}`), user).then(this.loadUsers)
    },
    update_role(user, role) {
      user.role = role
      this.update_user(user)
    },
    user_create() {
      this.axios.post(api(`users`), {login: this.new_login, role: "USER"})
          .then(resp => {
            this.create_user_message = `Hasło użytkownika to ${resp.data.password}. Zapisz je bo nie będzie ono później dostępne.`
            this.loadUsers();
          })
          .catch(() => this.create_user_message = "Nie udało się stworzyć użytkownika")
    },
    user_pass_reset(user) {
      this.axios.post(api(`users/${user.id}/reset`))
          .then(resp => {
            this.create_user_message = `Nowe hasło użytkownika to ${resp.data.new_password}. Zapisz je bo nie będzie ono później dostępne.`
          })
          .catch(() => this.create_user_message = "Nie udało się zresetować hasła")
    }


  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
